export var AuditSource;
(function (AuditSource) {
    AuditSource["USER"] = "USER";
    AuditSource["STAFF"] = "STAFF";
    AuditSource["SYSTEM"] = "SYSTEM";
    AuditSource["WEBHOOK"] = "WEBHOOK";
})(AuditSource || (AuditSource = {}));
export var AuditOutcome;
(function (AuditOutcome) {
    AuditOutcome["SUCCESS"] = "SUCCESS";
    AuditOutcome["FAILURE"] = "FAILURE";
})(AuditOutcome || (AuditOutcome = {}));
//# sourceMappingURL=audit.types.js.map